import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const PerformanceGraph = ({ data }) => {
  // Handle case where data is missing or empty
  if (!data || (Array.isArray(data) && data.length === 0) || (!Array.isArray(data) && (!data.labels || !data.datasets))) {
    return (
      <div className="flex items-center justify-center py-12 bg-gray-50 rounded">
        <div className="text-center">
          <p className="text-gray-500 text-lg">No performance data available</p>
          <p className="text-gray-400 text-sm mt-2">Performance data will appear once activity is recorded</p>
        </div>
      </div>
    );
  }

  // Determine if data is in the new format (array of objects) or old format (object with labels/datasets)
  let chartData = [];
  let lines = [];

  if (Array.isArray(data)) {
    chartData = data;
    // Get all keys from the first object except 'date'
    if (data.length > 0) {
      lines = Object.keys(data[0]).filter(key => key !== 'date');
    }
  } else {
    // Transform old format to recharts format
    chartData = data.labels.map((label, index) => {
      const dataPoint = { date: label };
      data.datasets.forEach(dataset => {
        dataPoint[dataset.label] = dataset.data[index];
      });
      return dataPoint;
    });
    lines = data.datasets.map(d => d.label);
  }

  const COLORS = [
    '#3B82F6', // Blue
    '#10B981', // Emerald
    '#F59E0B', // Amber
    '#EF4444', // Red
    '#8B5CF6', // Violet
    '#EC4899', // Pink
  ];

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={chartData} margin={{ top: 10, right: 30, left: 0, bottom: 20 }}>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E5E7EB" />
        <XAxis
          dataKey="date"
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 11, fill: '#6B7280' }}
          dy={10}
        />
        <YAxis
          axisLine={false}
          tickLine={false}
          tick={{ fontSize: 11, fill: '#6B7280' }}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: '#fff',
            border: '1px solid #E5E7EB',
            borderRadius: '8px',
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
            fontSize: '12px'
          }}
        />
        <Legend
          verticalAlign="top"
          align="right"
          iconType="circle"
          wrapperStyle={{ paddingBottom: '20px', fontSize: '12px' }}
        />
        {lines.map((lineKey, index) => (
          <Line
            key={lineKey}
            type="monotone"
            dataKey={lineKey}
            stroke={COLORS[index % COLORS.length]}
            strokeWidth={2.5}
            dot={{ r: 4, fill: COLORS[index % COLORS.length], strokeWidth: 2, stroke: '#fff' }}
            activeDot={{ r: 6, strokeWidth: 0 }}
            name={lineKey}
            animationDuration={1000}
          />
        ))}
      </LineChart>
    </ResponsiveContainer>
  );
};

export default PerformanceGraph;
